// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".profile img[data-v-4f5d26cc]{-o-object-fit:contain;object-fit:contain;width:22px}", "",{"version":3,"sources":["webpack://./resources/js/Shared/ProfileImg.vue"],"names":[],"mappings":"AAEM,8BACgB,qBAAA,CAAA,kBAAA,CAAd,UAAR","sourcesContent":["\n    .profile{\n      img{\n        width: 22px;  object-fit: contain;\n      }     \n    }\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
